import React, { Component } from 'react';
import PropTypes from "prop-types";
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Loading, FormGroup, Label, Input, Button, Toast, InputHint } from "spectre-react/dist/cjs";
import { loggedIn as loggedInAction } from '../store/actions';
import { fetchCurrentUser, signIn } from '../api';


class SignInPage extends Component {
    static propTypes = {
        currentUser: PropTypes.object,
        engineers: PropTypes.array,
    }

    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            fetchResponse: null,
            fetchError: null,

            name: '',
            password: '',

            passwordResetURL: '',

            isSubmitting: false,
            submitResponse: null,
            submitError: null,
        };

        this.abortController = null;
    }

    componentDidMount() {
        const { currentUser } = this.props;

        if (!currentUser) {
            this.doCheckAuth();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { fetchResponse } = this.state;
        const { currentUser, onLoggedIn } = this.props;

        // If previously there was no currentUser and now still no fetch, do fetch
        if (!currentUser && prevProps.currentUser !== currentUser) {
            this.doCheckAuth();
        }

        // When response comes and no location inside response, set user
        if (fetchResponse && fetchResponse !== prevState.response) {
            onLoggedIn(fetchResponse);
        }
    }

    componentWillUnmount() {
        // cancel any ongoing fetch if necessary
        if (this.abortController) {
            this.abortController.abort();
        }
    }

    doCheckAuth = async () => {
        this.setState({ isLoading: true });

        try {
            // Simple imitation of your useFetch hook behavior
            this.abortController = new AbortController();
            const response = await fetchCurrentUser({ signal: this.abortController.signal });

            this.setState({ isLoading: false, fetchResponse: response });
        } catch (error) {
            if (error.name !== 'AbortError') {
                const passwordResetURL = error.response?.data.passwordResetURL || '';
                this.setState({ isLoading: false, fetchError: error, passwordResetURL });
            }
        }
    };

    onChange = (ev) => this.setState({ [ev.target.name]: ev.target.value, submitError: '' });

    handleSubmit = (ev) => {
        ev.preventDefault();
        this.setState({isSubmitting: true});

        const {name, password} = this.state;
        signIn(name, password)
            .then(this.doCheckAuth)
            .catch(error => this.setState({isSubmitting: false, submitError: error.message}));
    };

    render() {
        const { currentUser } = this.props;
        const { isLoading } = this.state;

        if (currentUser) {
            return <Redirect to="/" />;
        }

        if (isLoading) {
            return <Loading large />;
        }

        const {
            name, password, isSubmitting, submitError,
            passwordResetURL
        } = this.state;

        return (
            <form id="sign-in-form" onSubmit={this.handleSubmit}>
                <img src="/logo.svg" className="img-responsive mb-4" alt="Логотип"/>

                <FormGroup>
                    <Label form htmlFor="name">Логин</Label>
                    <Input type="text" id="name" name="name" value={name} onChange={this.onChange} loading={isSubmitting} required autoFocus/>
                </FormGroup>

                <FormGroup>
                    <Label form htmlFor="password">Пароль</Label>
                    <Input type="password" id="password" name="password" value={password} onChange={this.onChange} loading={isSubmitting} required/>
                    <InputHint className="mb-0">
                        <a href={passwordResetURL}>Забыли пароль?</a>
                    </InputHint>
                </FormGroup>

                {submitError && <Toast className="mt-4">{submitError}</Toast>}

                <Button primary loading={isSubmitting} type="submit" className="mt-4">Войти</Button>
            </form>
        );
    }
}

const mapStateToProps = (state) => ({
    currentUser: state.currentUser,
});

const mapDispatchToProps = (dispatch) => ({
    onLoggedIn: (data) => dispatch(loggedInAction(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SignInPage);